// MyDocument.tsx
import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import logoamerisa from '../../assets/logoamerisa.png';
// const styles = StyleSheet.create({
//   page: { padding: 30 },
//   section: { marginBottom: 10 },
// });

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 10,
    padding: 20,
    position: 'relative',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#003366',
    color: 'white',
    padding: 10,
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: 'white',
  },
  content: {
    marginTop: 10,
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 20,
    right: 20,
    textAlign: 'left',
    borderTop: '1px solid #ccc',
    paddingTop: 5,
  },
  section: {
    marginBottom: 0,
  },
  title: {
    fontSize: 18,
    marginBottom: 10,
  },
  text: {
    marginBottom: 2,
  },
  smallText: {
    marginBottom: 2,
    fontSize: 8,
  },
  smallBold: {
    fontWeight: 'bold',
    fontSize: 8,
  },
  bold: {
    fontWeight: 'bold',
  },
  grid: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  column: {
    flex: 1,
    padding: 5,
  },
  borderBottom: {
    borderBottom: '1px solid #ccc',
    marginBottom: 10,
  },
  space: {
    marginBottom: 5,
  },
  extraSpace: {
    marginBottom: 30,
  },
  smallerExtraSpace: {
    marginBottom: 15,
  },
  orderSpace: {
    marginBottom: 10,
  },
  entregaSpace: {
    marginBottom: 50,
  },
  qrCode: {
    position: 'absolute',
    bottom: 20,
    right: 20,
    width: 100,
    height: 100,
  },
  topReference: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 5,
    marginBottom: 10,
  },
  referenceText: {
    fontSize: 12,
  },
  debugBox: {
    position: 'absolute',
    bottom: 5,
    left: 5,
    fontSize: 6,
    color: '#999',
  },
  contactFooter: {
    position: 'absolute',
    bottom: 30,
    left: 20,
    right: 20,
    textAlign: 'left',
    borderTop: '1px solid #ccc',
    paddingTop: 5,
  },
  contactTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 5,
    marginTop: 5,
  },
  contactSection: {
    marginBottom: 10,
  },
  contactGrid: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 3,
  },
  contactColumn: {
    width: '25%',
    paddingRight: 5,
    marginBottom: 5,
  },
  contactName: {
    fontSize: 8,
    fontWeight: 'bold',
  },
  contactEmail: {
    fontSize: 8,
  },
  contactPhone: {
    fontSize: 8,
  },
  stopSection: {
    marginTop: 6,
    paddingLeft: 4,
  },
  destinationSpace: {
    marginBottom: 8,
  },
});

const PdfTemplate = ({ selectedRowInbound }) => {
  console.log("PDF", selectedRowInbound)


  const requerimientosArray = JSON.parse(selectedRowInbound.requerimientos_adicionales);
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    });
  };

  const userName = localStorage.getItem('userName') ? localStorage.getItem('userName') : null;
  const role = localStorage.getItem('role') ? localStorage.getItem('role') : null;

  const OrigenesUnicos = [];
  const idsVistos = new Set();

  for (const contenedor of selectedRowInbound.contenedores) {
    if (!idsVistos.has(contenedor.id_origen)) {
      idsVistos.add(contenedor.id_origen);
      OrigenesUnicos.push(contenedor);
    }
  }


  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Image src={logoamerisa} style={{ height: 50 }} />
          <Text style={styles.headerTitle}>CARTA DE INSTRUCCIÓN</Text>
        </View>
        <View style={styles.content}>
          <View style={styles.topReference}>
            <Text style={styles.referenceText}>Folio de Embarque: {selectedRowInbound.referencia}</Text>
            {/* <Text style={styles.referenceText}>Truck: {"shipment.Truck"}</Text> por ahora no en inbound */}
          </View>
          <View style={styles.grid}>
            <View style={styles.column}>
              <Text style={[styles.text, styles.bold]}>DETALLES DE CARGA</Text>
              <View style={styles.borderBottom}></View>
              <Text style={styles.text}><Text style={styles.bold}>Fecha de carga:</Text> {formatDate(selectedRowInbound.fecha_de_carga)}</Text>
              <View style={styles.infoSpacing}></View>
              <Text style={styles.text}><Text style={styles.bold}>Origen:</Text></Text>
              <View>
                {OrigenesUnicos.map((contenedor, id) => (
                  <Text key={id} style={styles.text}>{contenedor.nombre_origen}</Text>
                ))}
              </View>
            </View>
            <View style={styles.column}>
              <Text style={[styles.text, styles.bold]}>DETALLES DE ENTREGA</Text>
              <View style={styles.borderBottom}></View>
              {selectedRowInbound.contenedores.map((contenedor, id) => {
                const isLast = id === selectedRowInbound.contenedores.length - 1;
                return (
                  <View
                    key={`unique-origin-${id}`}
                    style={[
                      styles.section,
                      !isLast && styles.destinationSpace  // 👉 solo si NO es el último
                    ]}
                  >
                    <Text style={styles.text}><Text>Destino {id + 1}:</Text></Text>
                    <Text style={styles.text}><Text>• Cliente:</Text> {contenedor.nombre_bodega}</Text>
                    <Text style={styles.text}><Text>• Destino:</Text> {contenedor.bodega_colonia}, {contenedor.bodega_estado}</Text>
                    <Text style={styles.text}><Text>• Fecha:</Text> {formatDate(contenedor.hora_de_cita)}</Text>
                  </View>
                );
              })}

            </View>
            <View style={styles.column}>
              <Text style={[styles.text, styles.bold]}>LINEA TRANSPORTISTA</Text>
              <View style={styles.borderBottom}></View>
              <Text style={styles.text}><Text style={styles.bold}>Nombre de la línea:</Text> {selectedRowInbound.linea_transporte}</Text>
              <Text style={styles.text}><Text style={styles.bold}>Nombre del operador:</Text> {selectedRowInbound.operador_nombre}</Text>
              <Text style={styles.text}><Text style={styles.bold}>Teléfono del operador:</Text> {selectedRowInbound.operador_telefono || 'No disponible'}</Text>
              <Text style={styles.text}><Text style={styles.bold}>Vehículo:</Text> {selectedRowInbound.vehiculo_placas}</Text>
              <Text style={styles.text}><Text style={styles.bold}>Remolque1:</Text> {selectedRowInbound.remolque1_placas}</Text>
              {selectedRowInbound.remolque2_placas && (<Text style={styles.text}><Text style={styles.bold}>Remolque2:</Text> {selectedRowInbound.remolque2_placas}</Text>)}
              <Text style={styles.text}><Text style={styles.bold}>Tipo:</Text> {selectedRowInbound.vehiculo_tipo}</Text>
            </View>
          </View>
          <View style={styles.smallerExtraSpace}></View>
          <Text style={styles.sectionTitle}>Órdenes Vinculadas</Text>
          <View style={styles.section}>
            <Text style={styles.smallBold}>Origen(es):</Text>
            {OrigenesUnicos.map((contenedor, id) => (
              // <Text key={id} style={styles.text}>{contenedor.nombre_origen}</Text>
              <View key={`unique-origin-${id}`} style={{ marginBottom: 5 }}>
                <Text style={styles.text}>
                  <Text >{contenedor.nombre_origen}</Text>
                </Text>
              </View>
            ))}

          </View>

          {selectedRowInbound.contenedores.map((contenedor, id) => {
            const isLast = id === selectedRowInbound.contenedores.length - 1;
            return (
              <View
                key={`unique-origin-${id}`}
                style={[
                  styles.section,
                  !isLast && styles.smallerExtraSpace  // 👉 solo si NO es el último
                ]}
              >
                <Text style={styles.text}><Text>Destino {id + 1}:</Text></Text>
                <Text style={styles.text}><Text>Dirección destino:</Text> {contenedor.bodega_direccion} {contenedor.bodega_ciudad_municipio}, {contenedor.bodega_estado}, {contenedor.bodega_codigo_postal}</Text>
                <Text style={styles.text}><Text>Contenedor:</Text> {contenedor.contenedor}</Text>
                <Text style={styles.text}><Text>Cantidad Total:</Text> {contenedor.cantidad}</Text>
                <Text style={styles.text}><Text>Puerta Vacio:</Text> {contenedor.nombre_puerta_vacio}</Text>
                <Text style={styles.text}><Text>Dir. Puerta vacio:</Text> {contenedor.puerta_vacio_direccion} {contenedor.puerta_vacio_ciudad}, {contenedor.puerta_vacio_estado}, {contenedor.puerta_vacio_codigo_postal}</Text>
              </View>
            );
          })}




          <View style={styles.smallerExtraSpace}></View>
          <Text style={styles.title}>Requerimientos Obligatorios</Text>
          <View style={styles.section}>
            <Text style={styles.text}>
              <Text style={styles.bold}>Requerimientos: </Text>
              {requerimientosArray.map((reque, index) => {
                const isLast = index === requerimientosArray.length - 1;

                return (
                  <Text key={index}>{reque.requerimiento}{!isLast && ', '}</Text> // esta coma puede dar problemas si está fuera de Text o mal colocada

                );
              })}

            </Text>
            <View style={styles.space}></View>
            <Text style={styles.text}>* En caso de no cumplirse Amerisa Logistics se reserva el derecho de no llevar a cabo el embarque o aplicar las sanciones correspondientes</Text>
          </View>

        </View>
        <View style={styles.footer}>
          <Text><Text style={styles.bold}>Generado por:</Text> {userName && (userName)}</Text>
          <Text><Text style={styles.bold}>Puesto:</Text> {role && (role)}</Text>
        </View>
      </Page>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Image src={logoamerisa} style={{ height: 50 }} />
          <Text>Condiciones Generales</Text>
        </View>
        <View style={styles.content}>
          <Text style={styles.text}>Favor de cumplir con todos los lineamientos que nos solicita la empresa, de lo contrario NO PODRÁN INGRESAR a las instalaciones:</Text>
          <View style={styles.space}></View>
          <Text style={styles.title}>Equipo de proteccion personal (EPP)</Text>
          <Text style={styles.text}>Zapatos de seguridad</Text>
          <Text style={styles.text}>Lentes</Text>
          <Text style={styles.text}>Casco</Text>
          <Text style={styles.text}>Chaleco reflejante color naranja</Text>
          <Text style={styles.text}>Credencial de su empresa (para utilizar como identificación)</Text>
          <View style={styles.space}></View>
          <Text style={styles.text}>Favor de proporcionar cuenta espejo a los siguientes correos:</Text>
          <View style={styles.space}></View>
          <Text style={styles.text}>• centrodemonitoreo@amerisa.com.mx</Text>
          <Text style={styles.text}>• centrodemonitoreo2@amerisa.com.mx</Text>
          <Text style={styles.text}>• centrodemonitoreo3@amerisa.com.mx</Text>
          <Text style={styles.text}>• centrodemonitoreo4@amerisa.com.mx</Text>
          <View style={styles.space}></View>
          <Text style={styles.title}>Especificaciones de la unidad:</Text>
          <Text style={styles.text}>Las unidades deben contar con póliza de seguro.</Text>
          <Text style={styles.text}>Los operadores deben portar: vestimenta limpia, zapatos de seguridad, casco, chaleco reflejante y cubrebocas en todo momento.</Text>
          <Text style={styles.text}>Los operadores no pueden fumar, beber ni masticar chicle durante el servicio.</Text>
          <Text style={styles.text}>Operadores atentos a instrucciones y servicio al cliente, con licencia vigente.</Text>
          <View style={styles.space}></View>
          <Text style={styles.title}>Entrega-Recepcion</Text>
          <Text style={styles.text}>Se debe confirmar recepción de folios y compartirlos vía WhatsApp</Text>
        </View>
        <View style={styles.contactFooter}>
          <Text style={styles.contactTitle}>Contacto</Text>
          <View style={styles.contactSection}>
            <Text style={styles.contactTitle}>Procuración</Text>
            <View style={styles.contactGrid}>
              <View style={styles.contactColumn}>
                <Text style={styles.contactName}>Rafael Campos</Text>
                <Text style={styles.contactEmail}>j_campos@amerisa.com.mx</Text>
                <Text style={styles.contactPhone}>+52 55 2109 7185</Text>
              </View>
              <View style={styles.contactColumn}>
                <Text style={styles.contactName}>Fidel Morales</Text>
                <Text style={styles.contactEmail}>l_morales@amerisa.com.mx</Text>
                <Text style={styles.contactPhone}>+52 55 8064 3166</Text>
              </View>
              <View style={styles.contactColumn}>
                <Text style={styles.contactName}>Alexia Cuevas</Text>
                <Text style={styles.contactEmail}>trafico_tul2@amerisa.com.mx</Text>
                <Text style={styles.contactPhone}>+52 55 3438 1281</Text>
              </View>
              <View style={styles.contactColumn}>
                <Text style={styles.contactName}>Israel Silva</Text>
                <Text style={styles.contactEmail}>i_silva@amerisa.com.mx</Text>
                <Text style={styles.contactPhone}>+52 55 7856 7700</Text>
              </View>
            </View>
          </View>
          <View style={styles.contactSection}>
            <Text style={styles.contactTitle}>Tráfico</Text>
            <View style={styles.contactGrid}>
              <View style={styles.contactColumn}>
                <Text style={styles.contactName}>Diego Diaz</Text>
                <Text style={styles.contactEmail}>d_diaz@amerisa.com.mx</Text>
                <Text style={styles.contactPhone}>+52 999 649 0054</Text>
              </View>
              <View style={styles.contactColumn}>
                <Text style={styles.contactName}>Carolina Perez</Text>
                <Text style={styles.contactEmail}>trafico_tul@amerisa.com.mx</Text>
                <Text style={styles.contactPhone}>+52 999 233 6984</Text>
              </View>
              <View style={styles.contactColumn}>
                <Text style={styles.contactName}>Trafico Teoloyucan</Text>
                <Text style={styles.contactEmail}>aux_trafico@amerisa.com.mx</Text>
                <Text style={styles.contactPhone}>+52 55 1849 3669</Text>
              </View>
              <View style={styles.contactColumn}>
                <Text style={styles.contactName}>Trafico Texcoco</Text>
                <Text style={styles.contactEmail}>aux_traficotex@amerisa.com.mx</Text>
                <Text style={styles.contactPhone}>+52 55 4056 3941</Text>
              </View>
            </View>
          </View>
          <View style={styles.contactSection}>
            <Text style={styles.contactTitle}>Torre de Control</Text>
            <View style={styles.contactGrid}>
              <View style={styles.contactColumn}>
                <Text style={styles.contactName}>Luis Dzul</Text>
                <Text style={styles.contactEmail}>centrodemoniroreo@amerisa.com.mx</Text>
                <Text style={styles.contactPhone}>+52 999 357 0017</Text>
              </View>
              <View style={styles.contactColumn}>
                <Text style={styles.contactName}>Ricardo Velueta</Text>
                <Text style={styles.contactEmail}>centrodemonitoreo3@amerisa.com.mx</Text>
                <Text style={styles.contactPhone}>+52 999 271 6302</Text>
              </View>
              <View style={styles.contactColumn}>
                <Text style={styles.contactName}>Augusto Negron</Text>
                <Text style={styles.contactEmail}>centrodemonitoreo2@amerisa.com.mx</Text>
                <Text style={styles.contactPhone}>+52 999 368 0938</Text>
              </View>
              <View style={styles.contactColumn}>
                <Text style={styles.contactName}>Gema Poot</Text>
                <Text style={styles.contactEmail}>centrodemonitoreo4@amerisa.com.mx</Text>
                <Text style={styles.contactPhone}>+52 999 313 8145</Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
}

export default PdfTemplate;
